var module = angular.module('octopusApp.certificates', []);

module.config(function ($stateProvider) {

    $stateProvider.state("app.library.certificates", {
        url: '/certificates',
        layout: {
            libraryTab: 'certificates'
        },
        defaultSubRoute: 'app.library.certificates.index',
        template: '<ui-view></ui-view>'
    });

     $stateProvider.state("app.library.certificates.index", {
     url: '',
     layout: {
     title: 'Certificates'
     },
     templateUrl: 'areas/certificates/index/certificates_index.html',
     controller: 'CertificatesIndexController',
     controllerAs: 'vm',
     data: {archived: false}
     });

    $stateProvider.state("app.library.certificates.archive", {
        url: '/archive',
        layout: {
            title: 'Archived Certificates'
        },
        templateUrl: 'areas/certificates/index/certificates_index.html',
        controller: 'CertificatesIndexController',
        controllerAs: 'vm',
        data: {
            archived: true
        }
    });

    $stateProvider.state("app.library.certificates.new", {
        url: '/new',
        layout: {
            title: 'New Certificate'
        },
        templateUrl: 'areas/certificates/new/certificate_new.html',
        controller: 'CertificateNewController'
    });

    $stateProvider.state("app.library.certificates.details", {
        url: '/:id',
        layout: {
            title: 'Certificate Details'
        },
        templateUrl: 'areas/certificates/details/certificate_details.html',
        controller: 'CertificateDetailsController',
        controllerAs: 'vm'
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/certificates_module.js
// module id = 8089705472219844
// module chunks = 1